import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import { ArrowLeft } from "lucide-react";

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="wb-container py-32 text-center"><h1 className="wb-h2">Yazı bulunamadı</h1><Link to="/blog" className="wb-btn-secondary mt-8 inline-flex">Tüm yazılar</Link></div>;
  if (!post) return <div className="wb-container py-32 text-[#a0aabf]">Yükleniyor...</div>;

  return (
    <>
      <SEO
        title={post.seo_title || post.title}
        description={post.seo_description || post.excerpt}
        image={post.cover_image}
        type="article"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          headline: post.title,
          datePublished: post.created_at,
          author: { "@type": "Person", name: post.author },
          image: post.cover_image,
        }}
      />
      <article className="pt-28 pb-24">
        <div className="wb-container max-w-3xl">
          <Link to="/blog" className="text-sm text-[#a0aabf] hover:text-[#d4af37] inline-flex items-center gap-2">
            <ArrowLeft size={14} /> Tüm yazılar
          </Link>
          <div className="mt-8">
            <div className="wb-overline">{(post.tags && post.tags[0]) || "Yazı"}</div>
            <h1 className="wb-h1 mt-3" data-testid="blog-title">{post.title}</h1>
            <div className="text-sm text-[#a0aabf] mt-5">
              {post.author} · {new Date(post.created_at).toLocaleDateString("tr-TR", { year: "numeric", month: "long", day: "numeric" })}
            </div>
          </div>
          {post.cover_image && (
            <div className="mt-10 aspect-[16/9] overflow-hidden bg-[#0c1f44]">
              <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
            </div>
          )}
          <div className="wb-prose mt-10">
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={{
                a: ({ href, children, ...props }) => {
                  const external = href && /^https?:\/\//.test(href);
                  if (external) return <a href={href} target="_blank" rel="noopener noreferrer" {...props}>{children}</a>;
                  return <Link to={href || "#"}>{children}</Link>;
                },
              }}
            >
              {post.content}
            </ReactMarkdown>
          </div>
          {post.tags?.length > 0 && (
            <div className="mt-12 flex flex-wrap gap-2">
              {post.tags.map((t) => (
                <span key={t} className="px-3 py-1 border border-white/10 text-xs uppercase tracking-widest text-[#a0aabf]">#{t}</span>
              ))}
            </div>
          )}
        </div>
      </article>
    </>
  );
}
